/**
 * Redux Slice for Notification Management
 * Manages the state of application notifications including adding and removing notifications
 */

import { createSlice } from "@reduxjs/toolkit";

/**
 * Redux slice for notification functionality
 * Provides actions and reducers for managing notification state
 * The slice name 'notifications' is used in Redux DevTools for debugging
 */
const notificationsSlice = createSlice({
  name: "notifications",
  /**
   * Initial state for the notifications slice
   * @type {Array} Empty array to store notification objects
   */
  initialState: [],
  reducers: {
    /**
     * Adds a new notification to the state
     * @param {Array} state - Current notifications state array
     * @param {Object} action - Redux action object
     * @param {Object} action.payload - Notification object to be added
     * @param {string} action.payload.id - Unique identifier for the notification
     */
    addNotification: (state, action) => {
      state.push(action.payload);
    },

    /**
     * Removes a notification from the state by its ID
     * @param {Array} state - Current notifications state array
     * @param {Object} action - Redux action object
     * @param {string} action.payload - ID of the notification to remove
     * @returns {Array} New state array with the specified notification removed
     */
    removeNotification: (state, action) => {
      return state.filter((notification) => notification.id !== action.payload);
    },
  },
});

/**
 * Exported notification actions for dispatch
 * Use these actions to add or remove notifications from any component
 */
export const { addNotification, removeNotification } =
  notificationsSlice.actions;

export default notificationsSlice.reducer;
